import {URL_BASE} from "../../../Globals.ts";

export const uploadMedia = async (isIncognito: boolean, user: any, base64Encoding: string, mediaType: string): Promise<string> => {
    return await uploadToStorage(base64Encoding, mediaType, isIncognito, user);
};

const uploadToStorage = async (base64String: string, mediaType: string, isIncognito: boolean, user: any): Promise<string> => {
    const url = `${URL_BASE}/api/simpleMediaUpload`;
    const bucketName = (!user || isIncognito) ? "temp" : user.uid;
    console.log(bucketName)

    const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ base64String, mediaType, bucketName })
    });

    if (!response.ok) {
        throw new Error(`Upload failed: ${response.status}`);
    }

    const { publicUrl } = await response.json();
    return publicUrl;
};
